import { useMemo } from 'react';
import config from 'config';
import useVideoConstraints from './useVideoConstraints';

export default () => {
  const { videoConstraints } = useVideoConstraints();
  const connectionOptions = useMemo(() => {
    const connectOption = {
      logLevel: config.isDevelopment ? 'debug' : 'warn',
      networkQuality: {
        local: 2,
        remote: 2,
      },
      dominantSpeaker: true,
      dominantSpeakerPriority: 'high',
      tracks: [],
      audio: true,
      video: videoConstraints,
      preferredVideoCodecs: 'auto',
      bandwidthProfile: {
        // https://www.twilio.com/docs/video/tutorials/using-bandwidth-profile-api#specifying-a-bw-profile
        video: {
          mode: 'grid',
          contentPreferencesMode: 'auto',
          clientTrackSwitchOffControl: 'auto',
          dominantSpeakerPriority: 'high',
          trackSwitchOffMode: 'disabled',
        },
      },
    };
    return connectOption;
  }, [videoConstraints]);

  return connectionOptions;
};
